import { AxiosPromise } from "axios";
import configs from "../configs";
import { RiderLiveApi } from "./live/RiderLiveApi";

export class RiderApis {
    private static riderApi: RiderLiveApi = new RiderLiveApi();

    // ==================== PUBLIC (NO AUTH) ====================

    static registerRider(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.registerRider(data);
        }
    }

    static checkApplicationStatus(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.checkApplicationStatus(data);
        }
    }

    static getPinStatus(): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.riderApi.getPinStatus();
    }

    static setWithdrawalPin(data: { pin: string; pin_confirmation: string }): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.riderApi.setWithdrawalPin(data);
    }

    static changeWithdrawalPin(data: { current_pin: string; new_pin: string; new_pin_confirmation: string }): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.riderApi.changeWithdrawalPin(data);
    }


    // ==================== FLEET: RIDER MANAGEMENT ====================

    static createFleetRider(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.createFleetRider(data);
        }
    }

    static getFleetRiders(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getFleetRiders(query);
        }
    }

    static getFleetStats(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getFleetStats();
        }
    }

    static getFleetRiderDetail(riderId: number, params?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getFleetRiderDetail(riderId, params);
        }
    }





    // ==================== ADMIN: RIDER APPLICATIONS ====================

    static getAllRiderApplications(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getAllRiderApplications(query);
        }
    }

    static getRiderApplicationStats(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getRiderApplicationStats();
        }
    }

    static getRiderApplicationDetails(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getRiderApplicationDetails(id);
        }
    }

    static approveRiderApplication(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.approveRiderApplication(id, data);
        }
    }

    static rejectRiderApplication(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.rejectRiderApplication(id, data);
        }
    }

    static updateRiderRate(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.updateRiderRate(id, data);
        }
    }

    static retryDojahVerification(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.retryDojahVerification(id);
        }
    }

    static toggleRiderFlag(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.toggleRiderFlag(id, data);
        }
    }

    // ==================== RIDER: WALLET ====================

    static getRiderWalletDashboard(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getRiderWalletDashboard();
        }
    }

    static getRiderTransactions(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getRiderTransactions(query);
        }
    }

    static requestWithdrawal(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.requestWithdrawal(data);
        }
    }

    static getRiderBankAccounts(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getRiderBankAccounts();
        }
    }

    static getBankList(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getBankList();
        }
    }

    static addBankAccount(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.addBankAccount(data);
        }
    }

    // ==================== ADMIN: WALLET MANAGEMENT ====================

    static getAllRiderWallets(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getAllRiderWallets(query);
        }
    }

    static getPendingWithdrawals(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getPendingWithdrawals(query);
        }
    }

    static approveWithdrawal(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.approveWithdrawal(id);
        }
    }

    static rejectWithdrawal(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.rejectWithdrawal(id, data);
        }
    }

    // ==================== ADMIN: FRAUD DASHBOARD ====================

    static getFraudDashboard(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getFraudDashboard();
        }
    }

    static getRiskyRiders(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getRiskyRiders(query);
        }
    }

    static getRiderTrustScore(userId: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getRiderTrustScore(userId);
        }
    }

    static getActiveDisputes(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getActiveDisputes(query);
        }
    }

    static bulkResolveDisputes(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.bulkResolveDisputes(data);
        }
    }

    static getFraudSettings(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.riderApi.getFraudSettings();
        }
    }
}